define(['app/modules/forms', 'app/modules/utilities'], function(Forms, Util) {
  var Career_pages = function () {};

  Career_pages.prototype.actionShow = function() {
    Util.applyClipboard('.copy', 'Copy to clipboard');

    $('.switch-list li').on('click', function() {
      var currentSection = $(this).closest('.section-block');
      $('.switch-list li', currentSection).removeClass('active');
      $(this).addClass('active');

      setTimeout(function() {
        $('.copy', currentSection).attr('data-clipboard-target', '#' + $('textarea:visible', currentSection).attr('id'));
      }, 50);
    });

    $(".ca-switcher:not('.mandatory') input").on("change", function() {
      var container = $(this).closest('.ca-switcher');
      var boxTitle = $(this).closest('.ca-company-box__item').find('.ca-company-box__item--title');
      var url = container.data('url');
      var id = container.data('id');
      var val = $('input[name="allow_listing_' + id + '"]:checked', container).val();

      $.ajax({
        type: 'PUT',
        url: url,
        data: { allow_listing: val },
        success: function(result){
          Forms.showSuccess(result);
          boxTitle.toggleClass('ca-company-box__item--title-off');
        },
        error: function(result) {
          container.toggleClass("off");
          container.find("input[type=radio]").each(function() {
            var item = $(this);
            if(!item.prop("checked")) {
              item.prop("checked", true);
              return false;
            }
          });
        }
      });
    });
  };

  return Career_pages;
});